export default "__VITE_ASSET__decbf727__"